import React from 'react';
import AnimatedElement from '../components/AnimatedElement.js';
import { RadarIcon, AudienceMapIcon, CompassIcon, FingerprintIcon, ChatIcon } from '../components/MethodIcons.js';

const methodSteps = [
    { Icon: RadarIcon, title: 'Market Scan', subtitle: 'تحلیل محیط رقابتی', output: 'خروجی: شناسایی فرصت‌های تمایز' },
    { Icon: AudienceMapIcon, title: 'Audience Map', subtitle: 'شناخت عمیق مخاطب', output: 'خروجی: پرسونای استراتژیک' },
    { Icon: CompassIcon, title: 'Brand Strategy', subtitle: 'تعریف جایگاه و ارزش پیشنهادی', output: 'خروجی: پیام مرکزی و استراتژی برند' },
    { Icon: FingerprintIcon, title: 'Brand Identity', subtitle: 'ترجمه استراتژی به هویت بصری و کلامی', output: 'خروجی: هویت یکپارچه و قابل تشخیص' },
    { Icon: ChatIcon, title: 'Brand Communication', subtitle: 'طراحی نحوه ارتباط با مخاطب', output: 'خروجی: چارچوب ارتباطات و استراتژی محتوا' },
];

const WhoIAmSection = () => (
    <section id="who-am-i" className="min-h-screen py-16 sm:py-20 flex flex-col items-center justify-center bg-brand-black relative overflow-hidden px-4 sm:px-6 md:px-16">

        <AnimatedElement className="text-center z-10 mb-10 sm:mb-16">
            <h2
                className="block font-normal"
                style={{ fontFamily: 'pinar', color: '#FFF', fontSize: 'clamp(22px, 4.5vw, 40px)', direction: 'rtl', textAlign: 'center', lineHeight: 1.6 }}
            >
                <a style={{ color: '#ff2a3f', fontFamily: 'pinar' }}>متد برندینگ ما</a> برای حل همین مسئله طراحی شده است
            </h2>
        </AnimatedElement>

        <div className="z-10 w-full max-w-6xl grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-x-4 sm:gap-x-6 gap-y-10 sm:gap-y-12">
            {methodSteps.map(({ Icon, title, subtitle, output }, index) => (
                <AnimatedElement key={title} type="fadeUp" delay={index * 150} className="flex flex-col items-center text-center">
                    <Icon className="w-14 h-14 sm:w-20 sm:h-20 md:w-24 md:h-24 text-brand-red mb-3 sm:mb-4" />
                    <h3 className="font-bold text-white text-sm sm:text-base md:text-lg" style={{ fontFamily: 'pinar' }}>{title}</h3>
                    <p className="text-brand-cream/80 text-xs sm:text-sm mt-1" style={{ fontFamily: 'pinar' }}>{subtitle}</p>
                    <p className="text-brand-cream/50 text-[11px] sm:text-xs mt-1" style={{ fontFamily: 'pinar' }}>{output}</p>
                </AnimatedElement>
            ))}
        </div>

       

    </section>
);

export default WhoIAmSection;
